import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import ProjectList from '../components/ProjectList';

const ProjectsPage = () => {
  const navigate = useNavigate();

  const header = (
    <div className="flex align-items-center justify-content-between p-3">
      <h1 className="m-0">Gestión de Proyectos</h1>
      <Button
        label="Nuevo Proyecto"
        icon="pi pi-plus"
        className="p-button-primary"
        onClick={() => navigate('/admin/projects/create')}
      />
    </div>
  );

  return (
    <div className="p-4">
      <Card header={header} className="shadow-2">
        <ProjectList />
      </Card>
    </div>
  );
};

export default ProjectsPage;